import './Button.css'

/**
 * Primary action element. Renders an <a> when `href` is supplied so that
 * in-page navigation stays keyboard- and screen-reader-correct.
 */
export function Button({
  variant = 'primary',
  size = 'md',
  full = false,
  disabled = false,
  children,
  onClick,
  href,
  style,
  ...rest
}) {
  const cls =
    'u-btn u-btn--' + variant + ' u-btn--' + size + (full ? ' u-btn--full' : '')

  if (href) {
    return (
      <a className={cls} href={href} style={style} {...rest}>
        {children}
      </a>
    )
  }

  return (
    <button
      type="button"
      className={cls}
      disabled={disabled}
      onClick={onClick}
      style={style}
      {...rest}
    >
      {children}
    </button>
  )
}

export default Button
